import { useI18n } from "../../i18n/LanguageProvider";
import { Container, SectionLabel } from "../Container";
import { Reveal } from "../Reveal";
import { UserPlus, SlidersHorizontal, Send, CheckCircle2 } from "lucide-react";

const icons = [UserPlus, SlidersHorizontal, Send, CheckCircle2];

export function HowItWorks() {
  const { t } = useI18n();
  const steps = t("how.steps");

  return (
    <section id="how" className="scroll-mt-24 py-32 md:py-40">
      <Container>
        <div className="max-w-3xl">
          <SectionLabel>{t("how.label")}</SectionLabel>
          <Reveal>
            <h2 className="text-3xl font-semibold leading-tight tracking-tight text-black sm:text-4xl lg:text-5xl">
              {t("how.title")}
            </h2>
          </Reveal>
        </div>

        <div className="mt-20 grid grid-cols-1 gap-8 md:grid-cols-4 md:gap-6">
          {steps.map((step, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={step.title} delay={i * 0.08}>
                <div className="relative">
                  <div className="flex items-center gap-4">
                    <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-black/10 bg-white text-black">
                      <Icon strokeWidth={1.5} className="h-5 w-5" />
                    </div>
                    <span className="font-mono text-sm text-black/30">0{i + 1}</span>
                  </div>
                  <h3 className="mt-6 text-lg font-semibold tracking-tight text-black">{step.title}</h3>
                  <p className="mt-2 text-base leading-relaxed text-black/55">{step.text}</p>
                  {i < steps.length - 1 && (
                    <div className="absolute right-0 top-6 hidden h-px w-1/2 translate-x-1/2 bg-gradient-to-r from-black/10 to-transparent md:block" />
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
